export const SET_ENTRY_SIGNAL = 'SET_ENTRY_SIGNAL';

export type EntrySignalPayload = {
	theme?: string;
	channel?: string;
	promoCode?: string;
	mixName?: string;
	prompt?: string;
	/** Intro to Financial Advisor onboarding intent: retirement or invest. */
	intent?: string;
};

export const setEntrySignalAction = (payload: EntrySignalPayload) => ({
	type: SET_ENTRY_SIGNAL,
	payload,
});
